import { Button, Modal, Spin, Table } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import { CSVLink } from 'react-csv'

import { siteUrl } from '../../config/constants'
// import OTPAuthenticationModal from './OTPauthenticationModal'

const MobilesTableModal = ({ data, setVisible, visible, title }) => {
  const antIcon = <LoadingOutlined style={{ fontSize: 30 }} spin />

  const columns = [
    {
      title: 'Mobile No.',
      dataIndex: 'mobile',
    },
    {
      title: 'Amount',
      dataIndex: 'value',
    },
  ]
  const onRowClick = (record) => {
    return {
      onClick: () => {
        const win = window.open(`${siteUrl}/customer-details/${record.mobile}`, '_blank')
        win.focus()
      },
    }
  }

  return (
    <>
      <Modal
        className='TableModal'
        title={title}
        // closeIcon={false}
        closable={false}
        open={visible}
        // onOk={handleOk}
        onCancel={() => {
          setVisible(false)
        }}
        footer={false}
        width={1000}
      >
        {data !== null ? (
          <>
            <div style={{ marginBottom: '1rem', display: 'flex', gap: '0.4rem' }}>
              {/* <OTPAuthenticationModal> */}
              <CSVLink
                data={data}
                headers={[
                  { label: 'Mobile', key: 'mobile' },
                  { label: 'Value', key: 'total' },
                ]}
                filename={`${title}.csv`}
              >
                <Button type='primary' className='btn-primary btn-primary-glow'>
                  Export Customers
                </Button>
              </CSVLink>
              {/* </OTPAuthenticationModal> */}
            </div>
            <Table
              dataSource={data?.map((customer, i) => ({
                key: i,
                mobile: customer?.mobile,
                value: 'Rs. ' + customer?.total?.toLocaleString(),
              }))}
              onRow={onRowClick}
              columns={columns}
              size='small'
              className='table_pagination'
              pagination={{
                position: ['bottomLeft'],
                // pageSize: 4,
                defaultPageSize: 10,
              }}
            />
          </>
        ) : (
          <div
            style={{
              height: '400px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Spin indicator={antIcon} />
          </div>
        )}
      </Modal>
    </>
  )
}
export default MobilesTableModal
